export type SiteLang = 'en' | 'zh';

export const normalizeSiteLang = (value?: string | null): SiteLang => {
  if (!value) return 'en';
  const lowered = value.toLowerCase();
  if (lowered === '_ch' || lowered === 'ch' || lowered.startsWith('zh')) {
    return 'zh';
  }
  return 'en';
};

export const isZhLang = (value?: string | null): boolean => normalizeSiteLang(value) === 'zh';

export const resolveUserDisplayName = (
  candidates: {
    username?: string | null;
    nickname?: string | null;
    email?: string | null;
    mobile?: string | null;
    nowid?: string | null;
  }
): string => {
  const { username, nickname, email, mobile, nowid } = candidates;

  // 1. Explicit nickname / username
  if (nickname?.trim()) return nickname.trim();
  if (username?.trim()) return username.trim();

  // 2. Identity-based fallback (Prefer Mobile for all users)
  if (mobile?.trim()) return mobile.trim();
  if (email?.trim()) return email.trim();

  // 3. Absolute fallback
  return nowid?.trim() || '';
};
